import { c as _c } from "react/compiler-runtime";
import { FeatherCheck, FeatherX } from '@subframe/core';
import type { CanalAuditoriaCertificado, CanalComunicacaoCertificado, DestinatarioAuditoriaCertificado, EventoAuditoriaCertificado, TentativaAuditoria, VarianteStatusCertificado } from '../../../types/certificadoAcessosTypes';
import { CANAL_LABEL, CanalIcone } from '../documento/CanalIcone';
const PONTO: Record<VarianteStatusCertificado, string> = {
  success: 'bg-success-600',
  warning: 'bg-warning-500',
  error: 'bg-error-500',
  neutral: 'bg-neutral-400'
};
const TEXTO: Record<VarianteStatusCertificado, string> = {
  success: 'text-success-700',
  warning: 'text-warning-700',
  error: 'text-error-600',
  neutral: 'text-neutral-500'
};
const TEXTO_AUDITORIA_ESCOPO = 'Dados técnicos completos para fins de perícia e análise jurídica, organizados por canal e por parte, mostrando cada tentativa de comunicação.';
const TEXTO_AUDITORIA_PROVEDORES_PADRAO = 'Para o envio das comunicações, utilizamos as plataformas Infobip, Pontaltech, AWS, Azure da Microsoft, Meta e Correios do Brasil, todas reconhecidas por sua alta confiabilidade no mercado. Essas plataformas possuem certificações de segurança ISO, assegurando que todos os dados transmitidos são protegidos e autênticos, conforme os mais altos padrões de segurança digital.';
interface SecaoAuditoriaIntroProps {
  textoEscopo?: string;
  textoProvedores?: string;
}
export function SecaoAuditoriaIntro(t0) {
  const $ = _c(7);
  const {
    textoEscopo: t1,
    textoProvedores: t2
  } = t0;
  const textoEscopo = t1 === undefined ? TEXTO_AUDITORIA_ESCOPO : t1;
  const textoProvedores = t2 === undefined ? TEXTO_AUDITORIA_PROVEDORES_PADRAO : t2;
  let t3;
  if ($[0] !== textoEscopo) {
    t3 = <p className="mb-[6px] text-[14px] text-neutral-700">{textoEscopo}</p>;
    $[0] = textoEscopo;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== textoProvedores) {
    t4 = <p className="mb-[14px] text-[13px] leading-[1.55] text-neutral-600">{textoProvedores}</p>;
    $[2] = textoProvedores;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = <div className="px-[37px]">{t3}{t4}</div>;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
interface TituloCanalAuditoriaProps {
  canal: CanalComunicacaoCertificado;
}
export function TituloCanalAuditoria(t0) {
  const $ = _c(7);
  const {
    canal
  } = t0;
  let t1;
  if ($[0] !== canal) {
    t1 = <CanalIcone canal={canal} className="h-[18px] w-[18px] flex-none" />;
    $[0] = canal;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = CANAL_LABEL[canal];
  let t3;
  if ($[2] !== t2) {
    t3 = <span className="text-[13px] font-bold tracking-[0.4px] whitespace-nowrap uppercase">Comprovações de envio — {t2}</span>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t3) {
    t4 = <div className="px-[37px] pt-2 pb-4"><div className="bg-brand-600/5 text-brand-600 flex items-center gap-[10px] rounded-[8px] px-4 py-[10px]">{t1}{t3}</div></div>;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}

// Timeline horizontal e compacta da história de tentativas com aquela parte.
function TimelineTentativas(t0) {
  const $ = _c(6);
  const {
    tentativas
  } = t0;
  let t1;
  if ($[0] !== tentativas) {
    let t2;
    if ($[2] !== tentativas.length) {
      t2 = (tentativa, index) => <div key={tentativa.indice} className="flex items-center"><div className="flex items-center gap-[8px] rounded-[8px] border border-solid border-neutral-200 bg-neutral-50 px-[10px] py-[6px]"><span className={`h-[8px] w-[8px] flex-none rounded-full ${PONTO[tentativa.variante]}`} /><div className="leading-tight"><div className="text-[11px] font-semibold text-neutral-700">{tentativa.tentativaLabel} · {tentativa.dataLabel}</div><div className={`text-[11px] font-medium ${TEXTO[tentativa.variante]}`}>{tentativa.resultadoLabel}</div></div></div>{index < tentativas.length - 1 && <div className="h-px w-5 flex-none bg-neutral-300" />}</div>;
      $[2] = tentativas.length;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    t1 = tentativas.map(t2);
    $[0] = tentativas;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div className="mb-4 flex flex-wrap items-center justify-start gap-y-2">{t1}</div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function ChipStatus(t0) {
  const $ = _c(2);
  const {
    sucesso
  } = t0;
  if (!sucesso) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <span className="bg-error-100 flex h-[20px] w-[20px] flex-none items-center justify-center rounded-[6px]"><FeatherX className="text-error-500 h-[12px] w-[12px]" /></span>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="bg-success-100 flex h-[20px] w-[20px] flex-none items-center justify-center rounded-[6px]"><FeatherCheck className="text-success-600 h-[13px] w-[13px]" /></span>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function colunasDaTabela(incluiMetadados: boolean) {
  return incluiMetadados ? 'grid-cols-[210px_1fr_1.5fr]' : 'grid-cols-[210px_1fr]';
}
function CabecalhoColunasEventos(t0) {
  const $ = _c(11);
  const {
    incluiMetadados,
    colunaDetalheTitulo
  } = t0;
  let t1;
  if ($[0] !== incluiMetadados) {
    t1 = colunasDaTabela(incluiMetadados);
    $[0] = incluiMetadados;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `grid ${t1} border-b border-solid border-neutral-200 bg-neutral-100 px-[14px] py-[9px] text-[11px] font-semibold tracking-[0.5px] text-neutral-500 uppercase`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div>Status</div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== colunaDetalheTitulo) {
    t4 = <div>{colunaDetalheTitulo}</div>;
    $[3] = colunaDetalheTitulo;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== incluiMetadados) {
    t5 = incluiMetadados && <div>Registro e metadados (ID e Hash)</div>;
    $[5] = incluiMetadados;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t4 || $[9] !== t5) {
    t6 = <div className={t2}>{t3}{t4}{t5}</div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function LinhaEvento(t0) {
  const $ = _c(23);
  const {
    evento,
    incluiMetadados,
    ultima
  } = t0;
  let t1;
  if ($[0] !== incluiMetadados) {
    t1 = colunasDaTabela(incluiMetadados);
    $[0] = incluiMetadados;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `grid ${t1} items-center px-[14px] py-[10px] ${ultima ? "" : "border-b border-solid border-neutral-100"}`;
  let t3;
  if ($[2] !== evento.sucesso) {
    t3 = <ChipStatus sucesso={evento.sucesso} />;
    $[2] = evento.sucesso;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== evento.statusLabel) {
    t4 = <span className="text-brand-600 text-[13px] font-medium">{evento.statusLabel}</span>;
    $[4] = evento.statusLabel;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div className="flex items-center gap-[10px]">{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = `text-[12.5px] ${evento.sucesso ? "text-neutral-700" : "text-neutral-500"}`;
  let t7;
  if ($[9] !== evento.respostaLabel) {
    t7 = evento.respostaLabel && <div className="mt-[3px] border-l-2 border-solid border-neutral-300 pl-[8px] text-[12px] wrap-anywhere whitespace-pre-wrap text-neutral-600 italic">“{evento.respostaLabel}”</div>;
    $[9] = evento.respostaLabel;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== evento.detalheLabel || $[12] !== t6 || $[13] !== t7) {
    t8 = <div className={t6}>{evento.detalheLabel}{t7}</div>;
    $[11] = evento.detalheLabel;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== evento.metadados || $[16] !== incluiMetadados) {
    t9 = incluiMetadados && <div className="text-[12px] leading-[1.45] wrap-anywhere text-neutral-700">{evento.metadados.length > 0 ? evento.metadados.map(_temp) : "\u2013"}</div>;
    $[15] = evento.metadados;
    $[16] = incluiMetadados;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t2 || $[19] !== t5 || $[20] !== t8 || $[21] !== t9) {
    t10 = <div className={t2}>{t5}{t8}{t9}</div>;
    $[18] = t2;
    $[19] = t5;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}
function _temp(metadado) {
  return <div key={metadado.rotulo}><strong>{metadado.rotulo}:</strong> {metadado.valor}</div>;
}
interface FatiaTabelaEventosProps {
  canal: CanalAuditoriaCertificado;
  tentativa: TentativaAuditoria;
  /** `null` na tentativa sem eventos: a fatia é só o cabeçalho das colunas, como antes. */
  evento: EventoAuditoriaCertificado | null;
  mostrarSubcabecalho: boolean;
  primeira: boolean;
  ultima: boolean;
  /** A fatia abre uma página no meio da tabela: repete o cabeçalho das colunas. */
  continuacao: boolean;
  /** Última fatia do destinatário: devolve o respiro que separava um destinatário do próximo. */
  fechaDestinatario: boolean;
}

/**
 * Uma linha paginável da tabela de eventos de uma tentativa.
 *
 * A tabela inteira era UM bloco de paginação, e o mecanismo empurra bloco atômico inteiro: quando
 * ela passou da altura da folha (a citação conversacional grava um evento por mensagem — cada
 * resposta da parte e cada aviso de entrega), o excedente caía sob o rodapé da página, cortado.
 * Mesmo recurso da réplica do e-mail (`ReplicaEmailFatia`): a moldura abre na primeira fatia e
 * fecha na última, e as do meio só têm as bordas laterais, então fatias adjacentes formam a mesma
 * tabela de antes.
 */
export function FatiaTabelaEventos(t0) {
  const $ = _c(22);
  const {
    canal,
    tentativa,
    evento,
    mostrarSubcabecalho,
    primeira,
    ultima,
    continuacao,
    fechaDestinatario
  } = t0;
  const abre = primeira || continuacao;
  const t1 = `px-[37px] ${fechaDestinatario ? "pb-[32px]" : ""}`;
  const t2 = ultima ? "mb-4" : "";
  let t3;
  if ($[0] !== mostrarSubcabecalho || $[1] !== primeira || $[2] !== tentativa) {
    t3 = primeira && mostrarSubcabecalho && <div className="mb-[6px] flex items-center gap-[8px] pl-[2px]"><span className={`h-[7px] w-[7px] flex-none rounded-full ${PONTO[tentativa.variante]}`} /><span className="text-[12px] font-semibold text-neutral-600">{tentativa.tentativaLabel} · {tentativa.dataLabel}</span></div>;
    $[0] = mostrarSubcabecalho;
    $[1] = primeira;
    $[2] = tentativa;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `overflow-hidden border-x border-solid border-neutral-200 ${abre ? "rounded-t-[8px] border-t" : ""} ${ultima ? "rounded-b-[8px] border-b" : ""}`;
  let t5;
  if ($[4] !== abre || $[5] !== canal) {
    t5 = abre && <CabecalhoColunasEventos incluiMetadados={canal.incluiMetadados} colunaDetalheTitulo={canal.colunaDetalheTitulo} />;
    $[4] = abre;
    $[5] = canal;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== canal || $[8] !== evento || $[9] !== ultima) {
    t6 = evento && <LinhaEvento evento={evento} incluiMetadados={canal.incluiMetadados} ultima={ultima} />;
    $[7] = canal;
    $[8] = evento;
    $[9] = ultima;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t7) {
    t8 = <div className={t2}>{t3}{t7}</div>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t1 || $[20] !== t8) {
    t9 = <div className={t1}>{t8}</div>;
    $[19] = t1;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}
interface CabecalhoAuditoriaDestinatarioProps {
  destinatario: DestinatarioAuditoriaCertificado;
}
export function CabecalhoAuditoriaDestinatario(t0) {
  const $ = _c(23);
  const {
    destinatario
  } = t0;
  const varianteFinal = destinatario.tentativas[destinatario.tentativas.length - 1]?.variante ?? "neutral";
  const multiplas = destinatario.tentativas.length > 1;
  const t1 = `px-[37px] ${destinatario.tentativas.length === 0 ? "pb-[32px]" : ""}`;
  let t2;
  if ($[0] !== destinatario.nome) {
    t2 = <span className="text-[14px] font-bold text-neutral-800">{destinatario.nome}</span>;
    $[0] = destinatario.nome;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== destinatario.papelLabel) {
    t3 = <span className="rounded-full bg-neutral-100 px-[8px] py-[2px] text-[10.5px] font-semibold tracking-[0.4px] text-neutral-500 uppercase">{destinatario.papelLabel}</span>;
    $[2] = destinatario.papelLabel;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== destinatario.tentativas.length || $[5] !== multiplas || $[6] !== varianteFinal) {
    t4 = multiplas && <span className={`flex items-center gap-[5px] text-[11px] font-medium ${TEXTO[varianteFinal]}`}><span className={`h-[6px] w-[6px] rounded-full ${PONTO[varianteFinal]}`} />{destinatario.tentativas.length} tentativas</span>;
    $[4] = destinatario.tentativas.length;
    $[5] = multiplas;
    $[6] = varianteFinal;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex items-center gap-2">{t2}{t3}{t4}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== destinatario.contatoLabel) {
    t6 = <div className="text-[12px] text-neutral-500">{destinatario.contatoLabel}</div>;
    $[12] = destinatario.contatoLabel;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className="mb-[16px] border-l-[3px] border-solid border-neutral-200 pl-3">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== destinatario.tentativas) {
    t8 = <TimelineTentativas tentativas={destinatario.tentativas} />;
    $[17] = destinatario.tentativas;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t1 || $[20] !== t7 || $[21] !== t8) {
    t9 = <div className={t1}>{t7}{t8}</div>;
    $[19] = t1;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}